import React, { useContext, useCallback, useState } from "react";
import { Tabs, Card } from "@shopify/polaris";
import { ProductProvider } from "app/product/modules/generic/context";

// import context
import { PrivateContext } from "lib/context/privateContext";

// import Hoc
import { withFeature } from "lib/hoc";

// import prop
import { tabProp } from "app/product/modules/generic/propTypes";
import constant from "lib/constant/constant";
import addData, { getPanelComponent } from "app/product/modules/operator/features/add/config/addData";

const ProductTabs = (props) => {
  const { setBanner, isMetafield } = props;
  const { cms, currentUser } = useContext(PrivateContext);
  // const { aws = {}, isAttachmentVisible = false } = currentUser || {};
  // const { bucket = "", path = "", id = "", secret = "" } = aws || {};
  const [selected, setSelected] = useState(0);
  const validProductTabs = addData(cms, "", isMetafield).tabs;
  // if (!isAttachmentVisible && bucket && path && id && secret) {
  //   validProductTabs.splice(-1);
  // }
  const tabLength = validProductTabs.length;

  const handleTabChange = useCallback((selectedTabIndex) => setSelected(selectedTabIndex), []);
  return (
    <>
      <Card>
        <Tabs tabs={validProductTabs} selected={selected} setBanner={setBanner} />
      </Card>
      <ProductProvider
        value={{
          setBanner,
          handleTabChange,
        }}
      >
        <div className="productComponent">{getPanelComponent(selected, cms, tabLength)}</div>
      </ProductProvider>
    </>
  );
};

ProductTabs.propTypes = tabProp.type;

export default withFeature(ProductTabs, {
  feature: constant.PRODUCT_ADD_FORM,
  // subFeature: constant.PRODUCT_ADD_FORM,
});
